import React from 'react';
import { Language } from '../lib/i18n';

// Props interface for the LanguageSelector component
interface LanguageSelectorProps {
  currentLanguage: Language;
  onLanguageChange: (lang: Language) => void;
}

/**
 * LanguageSelector component that provides language switching functionality
 * Displays buttons for each supported language (German and Japanese)
 * 
 * @param currentLanguage - Currently selected language
 * @param onLanguageChange - Callback function to handle language changes
 */
export function LanguageSelector({ currentLanguage, onLanguageChange }: LanguageSelectorProps) {
  return (
    <div className="flex items-center space-x-4">
      {/* German language button */}
      <button
        onClick={() => onLanguageChange('de')}
        className={`transition-colors ${
          currentLanguage === 'de'
            ? 'text-white'  // Active state
            : 'text-bamboo-100 hover:text-white'  // Inactive state
        }`}
      >
        DE
      </button>

      {/* Japanese language button */}
      <button
        onClick={() => onLanguageChange('ja')}
        className={`transition-colors ${
          currentLanguage === 'ja'
            ? 'text-white'  // Active state
            : 'text-bamboo-100 hover:text-white'  // Inactive state
        }`}
      >
        JP
      </button>
    </div>
  );
}